// extracted by mini-css-extract-plugin
export default {"noJsonError":"noJsonError---NdMWu","centerContainer":"centerContainer---c1fSt","center":"center---z3gEB","right":"right---UAbBx"};